import React from "react";
import {
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  Radar,
  Tooltip,
} from "recharts";
import { ChartStrategy } from "./ChartStrategy";
import { DYCHARTCOLORS } from "../../../../core/constants/chartStyles";

export class RadarChartStrategy extends ChartStrategy {
  render() {
    return (
      <RadarChart outerRadius={100} data={this.props.normalizedData}>
        <PolarGrid />
        <PolarAngleAxis dataKey={this.props.xAxis} />
        <PolarRadiusAxis />
        <Radar
          name={this.props.title}
          dataKey={this.props.yAxis}
          stroke={DYCHARTCOLORS[0]}
          fill={DYCHARTCOLORS[0]}
          fillOpacity={0.6}
        />
        <Tooltip content={<this.props.CustomTooltip />} />
      </RadarChart>
    );
  }
}
